module.exports = __webpack_public_path__ + "static/media/ascent-logo-black.26cc9099.svg";